import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { MentoringPreviewApi } from './mentoring-preview-api.interface';
import { getMentoringDetailsMock } from '../mocks';
import { GetMentoringDetailsRes } from '../models';

@Injectable()
export class MentoringPreviewApiMockService implements MentoringPreviewApi {
  getMentoringDetails(
    templateId: number,
  ): Observable<GetMentoringDetailsRes> {
    return of(getMentoringDetailsMock(templateId)).pipe(delay(500));
  }
}
